import React, { useState } from 'react';
import { Container, Grid, Typography, Box, IconButton, Collapse, Button, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import InfoIcon from '@mui/icons-material/Info';

const aboutText = `
LEMDA Pvt Ltd is a Colombo-based technology firm delivering web, mobile, 
and AI-powered software solutions to startups, SMEs, and enterprises worldwide.
Founded by a passionate team of developers and designers, we pride ourselves 
on creativity, reliability, and outstanding client support. Our deep expertise 
in React, React Native, Node.js, and OpenAI integrations ensures that every 
product we deliver is scalable, secure, and future-ready.
`;

export default function AboutSection() {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(false);

  return (
    <Box
      sx={{
        position: 'relative',
        py: 8,
        overflow: 'hidden',
      }}
    >
      {/* Subtle Gradient Overlay */}
      <Box
        component={motion.div}
        initial={{ scale: 1.2, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.1 }}
        transition={{ duration: 1 }}
        sx={{
          position: 'absolute',
          top: -100,
          right: -150,
          width: 400,
          height: 400,
          bgcolor: theme.palette.info.main,
          borderRadius: '50%',
        }}
      />
      <Container sx={{ position: 'relative', zIndex: 2 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <Box display="flex" alignItems="center" mb={2}>
                <InfoIcon sx={{ color: theme.palette.primary.main, mr: 1 }} />
                <Typography variant="h4" fontWeight={700} sx={{ color: theme.palette.primary.main }}>
                  About Us
                </Typography>
              </Box>
              <Typography variant="body1" color="text.secondary" paragraph>
                {aboutText.substring(0, expanded ? aboutText.length : 200)}{!expanded && '...'}
              </Typography>
              <Button
                size="small"
                onClick={() => setExpanded(!expanded)}
                sx={{
                  textTransform: 'none',
                  color: theme.palette.primary.main,
                  fontWeight: 600,
                }}
              >
                {expanded ? 'Read Less' : 'Read More'}
              </Button>
              {/* <Box sx={{ mt: 3 }}>
                <Typography fontWeight={600}>Headquarters:</Typography>
                <Typography variant="body2">World Trade Center, Colombo 01, Sri Lanka</Typography>
                <Typography variant="body2">Tel: +94 773 151 566</Typography>
              </Box> */}
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://gl-m.linker-cdn.net/profile/company/banner/2023/May/28/c935e5012ca03fd0bded4e2f561e44cd_t_crop_16852989236717.jpg"
              alt="Lemda Office"
              sx={{
                width: '100%',
                borderRadius: 2,
                boxShadow: 4,
                border: `4px solid ${theme.palette.primary.main}`
              }}
              as={motion.img}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
